// extracted by mini-css-extract-plugin
export var card = "SectionAnimationCard-module--card--e283a";
export var cardBack = "SectionAnimationCard-module--card-back--85400";
export var cardBackLabel = "SectionAnimationCard-module--card-back-label--43156";
export var cardFrontRed = "SectionAnimationCard-module--card-front-red--0816c";
export var cardFrontYellow = "SectionAnimationCard-module--card-front-yellow--b24da";
export var flippableCardContainer = "SectionAnimationCard-module--flippable-card-container--21310";